import { AloMission } from '@/models/alo/AloMission';
import { UiTabs } from '@/models/ui/UiTabs';
export class MissionUi {
    
    public mission:AloMission
    public tabsleft:UiTabs
    public tabsright:UiTabs
    public leftPanelWidth:string

    constructor({mission = new AloMission(), tabsleft = new UiTabs(), tabsright = new UiTabs(), leftPanelWidth = "50%"} = {}) {
        this.mission = mission
        this.tabsleft = new UiTabs(tabsleft)
        this.tabsright = new UiTabs(tabsright)
        this.leftPanelWidth = leftPanelWidth
    }
} 